import React from "react";

const FitConnect = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="282" height="60" viewBox="0 0 282 60">
    <defs>
      <filter id="prefix__Path_40" width="27.551" height="40.408" x="43.79" y="7.998" filterUnits="userSpaceOnUse">
        <feOffset dy="1" />
        <feGaussianBlur result="blur" stdDeviation="1" />
        <feFlood floodOpacity=".149" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter id="prefix__Path_41" width="10.295" height="40.408" x="67.942" y="7.998" filterUnits="userSpaceOnUse">
        <feOffset dy="1" />
        <feGaussianBlur result="blur-2" stdDeviation="1" />
        <feFlood floodOpacity=".149" />
        <feComposite in2="blur-2" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter id="prefix__Path_42" width="30.921" height="40.408" x="74.848" y="7.998" filterUnits="userSpaceOnUse">
        <feOffset dy="1" />
        <feGaussianBlur result="blur-3" stdDeviation="1" />
        <feFlood floodOpacity=".149" />
        <feComposite in2="blur-3" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter id="prefix__Path_43" width="41.458" height="56.914" x="1.28" y="2.572" filterUnits="userSpaceOnUse">
        <feOffset dy="1" />
        <feGaussianBlur result="blur-4" stdDeviation="1" />
        <feFlood floodOpacity=".149" />
        <feComposite in2="blur-4" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="prefix__Group_30420" transform="translate(-36 -32)">
      <g id="prefix__FitBigLogo" transform="translate(36 32)">
        <path id="prefix__Rectangle_1874" fill="rgba(255,255,255,0)" d="M0 0H107V60H0z" />
        <g id="prefix__Group_283" transform="translate(4.28 4.572)">
          <g id="prefix__Group_30090">
            <g filter="url(#prefix__Path_40)" transform="translate(42.51 5.426) translate(-46.79 -10)">
              <path
                id="prefix__Path_40-2"
                d="M975.417 1409.178v7.124H987.1a1.143 1.143 0 0 1 1.3 1.229v5.106a1.143 1.143 0 0 1-1.3 1.229h-11.683v10.914a1.143 1.143 0 0 1-1.3 1.229H968.4a1.143 1.143 0 0 1-1.3-1.229v-31.95a1.143 1.143 0 0 1 1.3-1.229h18.953a1.143 1.143 0 0 1 1.3 1.229v5.1a1.143 1.143 0 0 1-1.3 1.229h-11.936z"
                fill="#fff"
                transform="translate(-920.31 -1391.6)"
              />
            </g>
            <g filter="url(#prefix__Path_41)" transform="translate(42.51 5.426) translate(-46.79 -10)">
              <path
                id="prefix__Path_41-2"
                d="M1126.72 1401.688a1.712 1.712 0 0 0-.581-.088h-1.583a1.849 1.849 0 0 0-.581.088 1.093 1.093 0 0 0-.775 1.141v31.95c0 .79.484 1.229 1.356 1.229h1.583c.871 0 1.357-.439 1.357-1.229v-31.95a1.094 1.094 0 0 0-.776-1.141z"
                fill="#fff"
                transform="translate(-1052.26 -1391.6)"
              />
            </g>
            <g filter="url(#prefix__Path_42)" transform="translate(42.51 5.426) translate(-46.79 -10)">
              <path
                id="prefix__Path_42-2"
                d="M1189.821 1402.829v5.107a1.144 1.144 0 0 1-1.3 1.23h-7v25.613a1.143 1.143 0 0 1-1.3 1.229h-5.72a1.143 1.143 0 0 1-1.3-1.229v-25.613h-7a1.143 1.143 0 0 1-1.3-1.23v-5.107a1.142 1.142 0 0 1 1.3-1.229h22.324a1.157 1.157 0 0 1 1.296 1.229z"
                fill="#fff"
                transform="translate(-1087.05 -1391.6)"
              />
            </g>
          </g>
          <g filter="url(#prefix__Path_43)" transform="translate(-4.28 -4.57)">
            <path
              id="prefix__Path_43-2"
              fill="#00c5c5"
              d="M705.181 1415.9l-16.272-18.815s-6.719-.126-9.26-.279c-6.945-.43-9.833-4.887-9.62-11.091 0 0 .053-8.774.306-12.877.359-6.052 3.5-8.179 9.873-7.812a123.841 123.841 0 0 1 14.17 1.785c3.965.8 6.653 2.571 8.05 7.7.692 2.533 2.129 9.977 2.767 13.295.7 3.723.426 7.685-4.9 8.61z"
              transform="translate(-665.74 -1360.41)"
            />
          </g>
        </g>
      </g>
      <path
        id="prefix__Path_133513"
        d="M-72.3.3a12.818 12.818 0 0 1-6.509-1.6 10.668 10.668 0 0 1-4.268-4.549 15.053 15.053 0 0 1-1.488-6.869 14.941 14.941 0 0 1 1.488-6.851 10.691 10.691 0 0 1 4.269-4.531 12.818 12.818 0 0 1 6.508-1.6 14.438 14.438 0 0 1 4.806.791 10.646 10.646 0 0 1 3.8 2.23l-1.542 3.38a12.66 12.66 0 0 0-3.407-2 10.17 10.17 0 0 0-3.586-.629 6.962 6.962 0 0 0-5.649 2.373q-1.991 2.373-1.991 6.833 0 4.5 1.991 6.869a6.962 6.962 0 0 0 5.652 2.373 10.17 10.17 0 0 0 3.586-.629 12.66 12.66 0 0 0 3.407-2l1.542 3.38a10.646 10.646 0 0 1-3.8 2.23A14.438 14.438 0 0 1-72.3.3zm23.635 0a12.465 12.465 0 0 1-6.4-1.582 10.573 10.573 0 0 1-4.178-4.531 15.292 15.292 0 0 1-1.47-6.9A15.336 15.336 0 0 1-59.26-19.6a10.451 10.451 0 0 1 4.178-4.513 12.563 12.563 0 0 1 6.42-1.582 12.465 12.465 0 0 1 6.4 1.582 10.483 10.483 0 0 1 4.16 4.513 15.336 15.336 0 0 1 1.453 6.887 15.292 15.292 0 0 1-1.47 6.9A10.573 10.573 0 0 1-42.3-1.286 12.392 12.392 0 0 1-48.663.3zm0-3.7a6.609 6.609 0 0 0 5.435-2.417q1.955-2.409 1.955-6.9t-1.955-6.887A6.63 6.63 0 0 0-48.663-22a6.67 6.67 0 0 0-5.469 2.391q-1.955 2.391-1.955 6.887t1.955 6.9a6.648 6.648 0 0 0 5.469 2.414zm38.019-21.98V-.028h-3.479l-13.557-17.693V-.028h-4.3V-25.38h3.443l13.553 17.657V-25.38zm26.791 0V-.028h-3.479L-.891-17.721V-.028h-4.3V-25.38h3.443L11.805-7.723V-25.38zm5.451 0h16.929v3.668h-12.41v6.976h11.692v3.636H26.115v7.4h12.41v3.672H21.6zM54.126.3a12.818 12.818 0 0 1-6.509-1.6 10.668 10.668 0 0 1-4.268-4.549 15.053 15.053 0 0 1-1.488-6.869 14.941 14.941 0 0 1 1.488-6.851 10.691 10.691 0 0 1 4.267-4.531 12.818 12.818 0 0 1 6.509-1.6 14.438 14.438 0 0 1 4.806.791 10.646 10.646 0 0 1 3.8 2.23l-1.54 3.379a12.66 12.66 0 0 0-3.407-2 10.17 10.17 0 0 0-3.586-.629 6.962 6.962 0 0 0-5.649 2.373q-1.991 2.373-1.991 6.833 0 4.5 1.991 6.869A6.962 6.962 0 0 0 54.2-3.48a10.17 10.17 0 0 0 3.586-.629 12.66 12.66 0 0 0 3.407-2l1.542 3.38a10.646 10.646 0 0 1-3.8 2.23A14.438 14.438 0 0 1 54.126.3zM72.56-21.568h-8.248v-3.812h21.124v3.812h-8.249v21.54H72.56z"
        fill="#fff"
        transform="translate(232.564 72.704)"
      />
    </g>
  </svg>
);

export default FitConnect;
